<div class=" facilities page-holder bg-gray-100">
    <div class="container-fluid px-lg-4 px-xl-5 min-w-viewport">
        <div class="card-body">
            <ng-template #facilityModal>
                <!-- <app-add-users></app-add-users> -->
                <div class="text-start" id="editFacility">
                    <div class="modal-header border-0 bg-gray-100">
                        <h3 class="h5 text-uppercase modal-title" id="exampleModalLabel">Add a Facility</h3>
                        <button (click)="modalRef.hide()" class="btn-close" type="button" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-3">
                                <label>Facility Name</label>
                                <input class="form-control" type="text" placeholder="Facility Name">
                            </div>
                            <div class="mb-3">
                                <label>User Group</label>
                                <div class="dropdown">
                                    <select class="form-control" name="userGroup" [(ngModel)]="selectedUserGroup">
                                        <option>Facility 1 - Inspectors</option>
                                        <option>Facility 2 - Inspectors</option>
                                        <option>Facility 3 - Inspectors</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer border-0 bg-gray-100">
                        <button (click)="modalRef.hide()" class="btn btn-secondary" type="button">Close</button>
                        <button (click)="modalRef.hide()" class="btn btn-primary" type="button">Save changes</button>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="card-body">
            <ng-template #manageGroupMembers>
                <!-- <app-add-users></app-add-users> -->
                <div class="text-start" id="editFacility">
                    <div class="modal-header border-0 bg-gray-100">
                        <h3 class="h5 text-uppercase modal-title" id="exampleModalLabel">Manage Group Members</h3>
                        <button (click)="modalRef.hide()" class="btn-close" type="button" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <app-manage-group-members></app-manage-group-members>
                    </div>
                    <div class="modal-footer border-0 bg-gray-100">
                        <button (click)="modalRef.hide()" class="btn btn-primary" type="button">Close</button>
                    </div>
                </div>
            </ng-template>
        </div>
        <!-- Page Header-->
        <div class="page-header d-flex justify-content-between align-items-center">
            <h1 class="page-heading">Facilities</h1>
            <div><a (click)="openModal(facilityModal)" class="btn btn-primary text-uppercase"> <i
                        class="fa fa-plus me-2"> </i>Add new facility</a></div>
        </div>
        <div class="d-flex mb-3 mt-2">
            <label class="me-2 col-md-2">Select BU:</label>
            <div class="dropdown col-md-3">
                <select class="form-control" name="userGroup" [(ngModel)]="selectedUserGroup">
                    <option>BU 1</option>
                    <option>BU 2</option>
                    <option>BU 3</option>
                </select>
            </div>
        </div>
        <div class="d-flex mb-3 mt-2">
            <label class="me-2 col-md-2">Select Facility:</label>
            <div class="dropdown col-md-3">
                <select class="form-control" name="userGroup" [(ngModel)]="selectedUserGroup">
                    <option>Facility 1</option>
                    <option>Facility 2</option>
                    <option>Facility 3</option>
                </select>
            </div>
        </div>
        <div class="d-flex mb-3">
            <span class=" col-md-2 me-2">Inspector Group:
            </span>
            <a (click)="openModal(manageGroupMembers)" class="me-3 text-md text-success">Facility1-Inspectors</a>
        </div>
        <div class="d-flex mb-3">
            <span class=" col-md-2 me-2">Supervisor Group:
            </span>
            <a class="me-3 text-md text-success">Facility1-Supervisors</a>
        </div>
        <section>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <table class="table table-striped card-text">
                                <thead>
                                    <tr>
                                        <th>Form Name </th>
                                        <th>Facility Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of facilitiesData">
                                        <td>
                                            <div>
                                                {{row.title}}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {{row.facilityName}}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <a class="me-3 text-lg text-success"><i class="far fa-edit"></i></a><a
                                                    class="text-lg text-danger"><i class="far fa-trash-alt"></i></a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <app-footer class="footer-w"></app-footer>
    <div *ngIf="httpService.processing()">
        <app-progress-indicator></app-progress-indicator>
    </div>
</div>